import { render } from "./flashcards_actions.vue?vue&type=template&id=3131855a"
import script from "./flashcards_actions.vue?vue&type=script&lang=js"
export * from "./flashcards_actions.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__